import { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import Alert from "../components/Alert";

const Receipt = () => {
	const [alert] = useState({
		type: "working",
		text: "",
	});

	const history = useHistory();
	const location = useLocation();

	console.log(location);

	if (location?.state?.message?.type) {
		history.push("/dashboard/invoice", {
			replace: true,
			message: {
				type: location.state.message.type,
				text: location.state.message.text,
			},
		});
	} else {
		//history.push("/dashboard");
	}

	return <Alert data={alert} />;
};

export default Receipt;
